import React from 'react';

const categories = ['All', 'Vegetables', 'Fruits', 'Grains', 'Spices','Pulses', 'Legumes','Dried','Herbs', 'Dairy','Non-Veg','Others','Disappeared'];

const CategorySelector = ({ onSelect }) => (
  <div className="category-selector">
    {categories.map(cat => (
      <button key={cat} onClick={() => onSelect(cat)}>
        {cat}
      </button>
    ))}
  </div>
);

export default CategorySelector;
